<template>
  <div v-if="value">
    <img :src="value" class="responsive" @click="opened = !opened" :class="css">
  </div>
</template>
<script>
export default {
  name: 'grid-cell-image',
  data () {
    return {
      opened: false
    }
  },
  props: {
    row: Object,
    column: {
      required: true,
      type: Object
    },
    value: {
      default: () => ''
    },
    css: {
      type: String,
      default: () => 'grid-image'
    }
  }
}
</script>
